import { render, staticRenderFns } from "./employee_mg.vue?vue&type=template&id=02aeb2a1"
import script from "./employee_mg.vue?vue&type=script&lang=js"
export * from "./employee_mg.vue?vue&type=script&lang=js"
import style0 from "./employee_mg.vue?vue&type=style&index=0&id=02aeb2a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports